import React, { useEffect, useState, useRef } from 'react';
import data from '../data/data.json';
import { alterName } from '../utils';
import { Link } from 'gatsby';

export default function SearchBar() {
  const [query, setQuery] = useState('');
  const [hits, setHits] = useState([]);
  const currentIndex = useRef(0);
  const prevIndex = useRef(0);

  function focusSearch(e) {
    if (e.isComposing || e.keyCode === 229) {
      return;
    }

    if (e.key === '/') {
      e.preventDefault();
      if (document.getElementById('searchBar') === document.activeElement) {
        document.getElementById('searchBar').blur();
      } else {
        document.getElementById('searchBar').focus();
      }
    }
  }

  const navigate = e => {
    if (e.isComposing || e.keyCode === 229) {
      return;
    }

    // Down arrow
    if (e.keyCode === 40 && hits.length) {
      prevIndex.current = currentIndex.current;
      currentIndex.current = (currentIndex.current % hits.length) + 1;

      const selector = `#gatsby-focus-wrapper > main > div > ul > li:nth-child(${currentIndex.current}) > a`;
      const prevSelector = `#gatsby-focus-wrapper > main > div > ul > li:nth-child(${prevIndex.current}) > a`;

      let item = document.querySelector(selector);
      let prevItem = document.querySelector(prevSelector);

      if (item && (prevItem || prevIndex.current === 0)) {
        if (prevItem) prevItem.classList.remove('onFocus');
        item.classList.add('onFocus');
        item.focus();
      }
    }
    // Up arrow
    if (e.keyCode === 38 && hits.length) {
      prevIndex.current = currentIndex.current;
      currentIndex.current -= 1;
      if (currentIndex.current <= 0) currentIndex.current = hits.length;

      const selector = `#gatsby-focus-wrapper > main > div > ul > li:nth-child(${currentIndex.current}) > a`;
      const prevSelector = `#gatsby-focus-wrapper > main > div > ul > li:nth-child(${prevIndex.current}) > a`;

      let item = document.querySelector(selector);
      let prevItem = document.querySelector(prevSelector);

      if (item && (prevItem || prevIndex.current === 0)) {
        if (prevItem) prevItem.classList.remove('onFocus');
        item.classList.add('onFocus');
        item.focus();
      }
    }
  };

  useEffect(() => setQuery(window.localStorage.getItem('query')), []);

  useEffect(() => {
    if (query?.length === 0) {
      setHits([]);
      currentIndex.current = 0;
    }

    const to = setTimeout(() => {
      try {
        let sanitizedQuery = query.trim().toLowerCase();
        console.log(sanitizedQuery);
        if (sanitizedQuery?.length > 2) {
          let res = [];

          data.forEach(item => {
            const title = item.name.toLowerCase();

            if (title.includes(sanitizedQuery)) res.push(item);
          });

          setHits(res);
        }
      } catch (err) {
        console.error(err.message);
      }
    }, 250);

    return () => clearTimeout(to);
  }, [query]);

  useEffect(() => {
    window.addEventListener('keydown', focusSearch);

    return () => window.removeEventListener('keydown', focusSearch);
  });

  useEffect(() => {
    window.addEventListener('keydown', navigate);

    return () => window.removeEventListener('keydown', navigate);
  });

  useEffect(() => {
    return () => window.localStorage.setItem('query', query);
  }, [query]);

  return (
    <div className="search-box">
      <label htmlFor="searchBar">Find the item you wanna know!</label>
      <p className="fade">
        Shortcuts: You can also press / to start searching and ` to toggle Menu.
      </p>
      <input
        type="search"
        name="searchBar"
        id="searchBar"
        onChange={e => setQuery(e.target.value)}
        value={query}
        autoComplete="off"
      />
      <ul className="hits">
        {hits.map((item, i) => (
          <li key={i}>
            <Link className="hit" to={`/${alterName(item.name, true)}`}>
              <img
                src={`${alterName(item.name)}.png`}
                alt={item.name}
                width="32"
                height="32"
              />
              <span className="hit-name">{item.name}</span>
              <span className="fade">–&nbsp;&nbsp;{item.type}</span>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
